import appStore from './app'
import applyClaimStore from './applyClaim'
import claimTrackingStore from './claimTracking'

export const useAppStore = appStore
export const useApplyClaimStore = applyClaimStore
export const useClaimTrackingStore = claimTrackingStore
